import * as React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import { LookupValue } from "../../../models/lookup";
import { ILocalization } from "../../../models/localization";
import { ExperienceType, LookupType } from "../../../models/enums";
import SeekerStore from "../../../stores/seekerStore";
import { SkillFit, ExperienceSkill } from "../../../models/profile";
import { WorkExperience, EducationExperience, ActivityExperience, CCLCExperience } from "../../../models/profile";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import { Chart } from "react-google-charts";
import * as s from "./expMapping.css";

@observer
export default class ExperienceToSkills extends React.Component<{ store: SeekerStore }, {}> {
  private expChartRef: HTMLDivElement;
  constructor(props: any) {
    super(props);
    this.expChartRef = null
  }

  scrollToBottom = () => {
    this.expChartRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  renderChart(): JSX.Element[] {

    if (!this.props.store.profileStore.selectedExpHash || !this.props.store.profileStore.selectedExpType) {
      return null;
    }

    const local: ILocalization = this.props.store.localization.fields;
    const id: string = this.props.store.profileStore.selectedExpHash;
    const type: ExperienceType = this.props.store.profileStore.selectedExpType;
    const expSkills: Array<ExperienceSkill> = [];
    const chart: JSX.Element[] = [];

    switch (type) {
      case ExperienceType.Work:
        let we: WorkExperience = this.props.store.profileStore.profile.getWorkExperience(id);
        we.skills.map((s: ExperienceSkill): void => {
          expSkills.push(s);
        });
        break;
      case ExperienceType.Military:
        let me: WorkExperience = this.props.store.profileStore.profile.getWorkExperience(id);
        me.skills.map((s: ExperienceSkill): void => {
          expSkills.push(s);
        });
        break;
      case ExperienceType.Life:
        let ae: ActivityExperience = this.props.store.profileStore.profile.getActivityExperience(id);
        ae.skills.map((s: ExperienceSkill): void => {
          expSkills.push(s);
        });
        break;
      case ExperienceType.GEDDegree:
        let ee: EducationExperience = this.props.store.profileStore.profile.getEducationExperience(id);
        ee.skills.map((s: ExperienceSkill): void => {
          expSkills.push(s);
        });
        break;
      case ExperienceType.Course:
        let ec: EducationExperience = this.props.store.profileStore.profile.getEducationExperience(id);
        ec.skills.map((s: ExperienceSkill): void => {
          expSkills.push(s);
        });
        break;
    }

    if (expSkills.length > 0) {
      const items: Array<(string | number)[] | (string | { "role": string; })[]> = [];
      items.push(["Skill", local.freq, { "role": "style" }]);
      expSkills.map((skill: ExperienceSkill) => {
        let use: number = 7 - skill.used;
        items.push([this.props.store.profileStore.profile.getSkillName(skill.skillId), use, "color: #0072CE"]);
      });    
      if (items.length > 0) {
        chart.push(<div key={"exp-to-skill-chart"}>
          <Chart
            graph_id="skillChart"
            chartType="BarChart"
            ref="exp-to-skill-chart"
            data={items}
            options={{
              "bar": { "groupWidth": "50%" },
              "legend": { "position": "none" },
              "chartEvents": [{ "eventName": "onmouseover" }],
              "hAxis": {
                "title": local.freq,
                "ticks": [{ v: 0, f: local.profile.never }, { v: 1, f: local.profile.yearly }, { v: 2, f: local.profile.monthly }, { v: 3, f: local.profile.biweekly }, { v: 4, f: local.profile.weekly }, { v: 5, f: local.profile.week23 }, { v: 6, f: local.profile.daily }],
                "slantedText": true,
                "slantedTextAngle": 45,
                "format": 0
              },
              "chartArea": {
                "left": "20%",
                "top": "5%",
                "height": "auto",
                "width": "90%",
              },            
            }}
            height="450px"
            width="100%"
            legend_toggle />
        </div>)
      } 
    } else {
      chart.push(<div key="no-skills"><p>{local.profile.associatedSkillDefaultMsg}</p></div>)
    }   
    return chart;
  }

  render(): JSX.Element {
    if (!this.props.store.profileStore.profile) {
      return null;
    }
    const local: ILocalization = this.props.store.localization.fields;

    return (<div>
      <div style={{ float: "left", clear: "both" }} ref={(el) => { this.expChartRef = el; }}></div>
      <h5 className={s.header}>{local.profile.expChartHeader}</h5>
      {!this.props.store.profileStore.selectedExpHash && <p>{local.profile.expToSkillsChartMsg}</p>}
      {this.renderChart()}
    </div>)
  }  
}


// WEBPACK FOOTER //
// ./src/components/profile/experienceMapping/index.tsx